import "./Solutions.css";

const SoftwareSolutions = () => {
  const solutions = [
    "Web Technology",
    "Mobile Technology",
    "UI and UX Design",
    "Cloud Solutions",
    "Database Architecture",
    ".NET Development",
    "Node.js Solutions",
    "Blazor Applications",
    "React.js Development",
    "Python Development",
    "HTML5 Frontend",
    "API Integrations",
  ];

  return (
    <div id="solutions" className="software-solutions-container">
      <div className="solutions-content">
        <div className="left-column">
          <h1 className="solution-section-title">
            Solutions Designed To Fit Reality
          </h1>
          <p className="software-solutions-container__description">
            No two companies will ever grow the same. This is why our offerings
            are built on real business workflows, real users, and real-world
            constraints. We do not impose trends. Instead, we develop adaptive
            software solutions that adjust according to the evolution and
            responses of your business
          </p>
        </div>

        <div className="right-column">
          <div className="solutions-grid">
            {solutions.map((solution, index) => (
              <div key={index} className="solution-card">
                {solution}
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};

export default SoftwareSolutions;
